import React from 'react';
import { useTranslation } from 'react-i18next';
import { DeviationResourceType, DeviationTypes } from '../../types/deviation';
import ConfirmationModal from '../../Popup/ConfirmationModal';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import s from './ChangeTierPopup.scss';
import { BiData } from '@wix/da-bi/pkg/events';
export const ChangeTierPopup = ({ currentTier, newTier, isDowngrade, onChangeTier, close })=>{
    const { t } = useTranslation();
    if (currentTier.type !== DeviationTypes.TIER) {
        return null;
    }
    if (newTier.type !== DeviationTypes.TIER) {
        return null;
    }
    const changeType = isDowngrade ? t('deviation.tier.changePopup.type.downgrade') : t('deviation.tier.changePopup.type.upgrade');
    const content = /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, t('deviation.tier.changePopup.confirm.body', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        oldTitle: /*#__PURE__*/ React.createElement("strong", null, currentTier.title),
        newTitle: /*#__PURE__*/ React.createElement("strong", null, newTier.title),
        learnMore: /*#__PURE__*/ React.createElement(TextButton, {
            className: s['link'],
            variant: 'approval-green',
            size: 'large',
            href: t('deviation.tier.changePopup.confirm.body.kblink'),
            target: "_blank"
        }, t('deviation.tier.changePopup.confirm.body.learnMore'))
    }));
    return /*#__PURE__*/ React.createElement(ConfirmationModal, {
        isOpen: true,
        title: t('deviation.tier.changePopup.confirm.title'),
        text: content,
        confirmBtnType: isDowngrade ? 'danger' : 'default',
        confirmBtnLabel: t('deviation.tier.changePopup.confirm.accept', {
            changeType
        }),
        confirmBtnBiData: BiData({
            evid: 553,
            typeid: DeviationResourceType.TIER,
            itemid: newTier.deviationId,
            upgrade_type: isDowngrade ? 'downgrade' : 'upgrade'
        }),
        cancelBtnLabel: t('deviation.tier.changePopup.confirm.cancel'),
        onCancel: close,
        onConfirm: ()=>{
            onChangeTier(currentTier, newTier);
        }
    });
};
ChangeTierPopup.displayName = 'ChangeTierPopup';
export default ChangeTierPopup;

//# sourceMappingURL=ChangeTierPopup.js.map